import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialog } from '@core/models';

@Component({
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  standalone: false,
})
export class ConfirmDialogComponent implements OnInit {
  private data = inject<ConfirmDialog>(MAT_DIALOG_DATA);

  public confirmColor: string;
  public message: string;
  public innerHtml: string;
  public noButtonText: string;
  public title: string;
  public yesButtonText: string;

  public ngOnInit(): void {
    this.confirmColor = this.data?.confirmColor || 'primary';
    this.title = this.data?.title;
    this.message = this.data?.message;
    this.innerHtml = this.data?.innerHtml;
    this.noButtonText = this.data?.noButtonText || 'No';
    this.yesButtonText = this.data?.yesButtonText || 'Yes';
  }
}
